import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NgxDropzoneModule} from "ngx-dropzone";
import { AttachmentUploadComponent } from './attachment-upload/attachment-upload.component';

@NgModule({
  imports: [
    CommonModule,
    NgxDropzoneModule
  ],
  declarations: [AttachmentUploadComponent],
  exports:[AttachmentUploadComponent]
})
export class AttachmentModule { }



// WEBPACK FOOTER //
// /app/src/app/attachment/attachment.module.ts